import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

export default function DateCell({ value }) {
  return value == null || value === "" ? (
    <span className="tw:text-muted-foreground">{EM_DASH}</span>
  ) : (
    <span className="tw:block tw:truncate">{value}</span>
  );
}
